import fetchSuppliers from '../Services/fetchSuppliers';

export default () => async (dispatch) => {

  dispatch(fetchSuppliers());
  
}
